import { Button, Col, Row, Upload } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile, UploadProps } from 'antd/lib/upload/interface';
import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COMMON_ERROR, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { RootState } from '../../../store';
import { updateFileList } from '../../../store/actions/linkContextAction';
import { LinkContextModel } from '../../../store/models/linkContextModel';
import { fileBeforeUpload } from '../../../utils/fileUploadUtils';
import { ReactComponent as UploadIcon } from '../../../assets/images/svg/i_upload_icon.svg';
import { centeredNotification } from '../../../utils/utility';

const Uploader = ({ linkedTo }: any): ReactElement => {
  const dispatch = useDispatch();
  const { fileList: files } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const [isUploading, setIsUploading] = useState(false);

  const fileList = files[linkedTo] || [];

  const draggerActions: UploadProps = {
    beforeUpload: fileBeforeUpload,
    multiple: true,
    action: GLOBAL_URL.CRM_BASE_URL + 'Provider/File/Upload',
    withCredentials : true,
    onChange: (info: UploadChangeParam<UploadFile<any>>): any => {
      if (info?.file?.status === 'done') {
        const { isSuccess, errorMessage } = info?.file?.response || {};
        if (isSuccess) {
          fileList.push(info?.file);
          dispatch(updateFileList({ ...files, [linkedTo]: fileList }));
        } else {
          centeredNotification(errorMessage || COMMON_ERROR);
        }
      }
      const allDone = info?.fileList?.every(({ status }: UploadFile): boolean => !status || status === 'done');
      if (allDone) {
        setIsUploading(false);
      } else {
        setIsUploading(true);
      }
    },
  };

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE}>
        <Col md={12} className="m--15">
          <Upload
            {...draggerActions}
            itemRender={(): any => null}
          >
            <Button type="text" icon={<UploadIcon />} loading={isUploading} />
          </Upload>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Uploader;
